var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegistered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.421326,
    y: 0.0791016,
    width: 76,
    height: 76,
    rx: 25,
    fill: "#DBEAFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0047 19.2182C49.1475 19.9055 50.093 20.8769 50.7493 22.0378C51.4056 23.1987 51.7504 24.5096 51.7501 25.8432C51.7504 27.1767 51.4056 28.4877 50.7493 29.6486C50.093 30.8095 49.1475 31.7808 48.0047 32.4682M60.5834 57.864V56.539C60.5834 51.5923 60.5834 49.119 59.6206 47.2287C58.7737 45.5667 57.4224 44.2154 55.7604 43.3685M32.9792 33.5723C33.9943 33.5723 34.9993 33.3724 35.9371 32.984C36.8748 32.5956 37.7269 32.0262 38.4446 31.3085C39.1623 30.5908 39.7316 29.7388 40.1201 28.801C40.5085 27.8633 40.7084 26.8582 40.7084 25.8432C40.7084 24.8282 40.5085 23.8231 40.1201 22.8854C39.7316 21.9476 39.1623 21.0956 38.4446 20.3778C37.7269 19.6601 36.8748 19.0908 35.9371 18.7024C34.9993 18.3139 33.9943 18.114 32.9792 18.114C30.9293 18.114 28.9634 18.9283 27.5139 20.3778C26.0644 21.8273 25.2501 23.7933 25.2501 25.8432C25.2501 27.8931 26.0644 29.859 27.5139 31.3085C28.9634 32.758 30.9293 33.5723 32.9792 33.5723ZM16.4167 56.539V57.864H49.5417V56.539C49.5417 51.5923 49.5417 49.119 48.5789 47.2287C47.732 45.5667 46.3808 44.2154 44.7187 43.3685C42.8284 42.4057 40.3551 42.4057 35.4084 42.4057H30.5501C25.6034 42.4057 23.1301 42.4057 21.2397 43.3685C19.5777 44.2154 18.2265 45.5667 17.3796 47.2287C16.4167 49.119 16.4167 51.5923 16.4167 56.539Z",
    stroke: "#2B57FB",
    strokeWidth: 1.93422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistered);
export default __webpack_public_path__ + "static/media/Registered.aa9ae8ee113ffb8dceb9b005883b3840.svg";
export { ForwardRef as ReactComponent };